import { MenuItem } from "@blueprintjs/core";
import { ItemRenderer } from "@blueprintjs/select";

export const SuffixMenuItemRenderer: ItemRenderer<string> = (
  v,
  { handleClick, modifiers }
) => (
  <MenuItem text={v} onClick={handleClick} key={v} active={modifiers.active} />
);
